/** Copy de produto: MegaCap usa Bilhete(s); demais temas usam Título(s). */

export function isMegaCapTheme(): boolean {
  return import.meta.env.VITE_APP_THEME === "MegaCap";
}

/** Plural com acento inicial: "Títulos" | "Bilhetes" */
export function labelPlural(): string {
  return isMegaCapTheme() ? "Bilhetes" : "Títulos";
}

/** Singular com acento: "Título" | "Bilhete" */
export function labelSingular(): string {
  return isMegaCapTheme() ? "Bilhete" : "Título";
}

/** Plural minúsculo no meio da frase: "títulos" | "bilhetes" */
export function labelPluralLower(): string {
  return isMegaCapTheme() ? "bilhetes" : "títulos";
}

/** Singular minúsculo: "título" | "bilhete" */
export function labelSingularLower(): string {
  return isMegaCapTheme() ? "bilhete" : "título";
}

/** Forma "título(s)" | "bilhete(s)" para textos legais/informativos */
export function labelSingularPluralParenteses(): string {
  return isMegaCapTheme() ? "bilhete(s)" : "título(s)";
}

/** Estilo label sem acento (ex.: Qtd. Titulos): "Titulos" | "Bilhetes" */
export function labelPluralTitulosSemAcento(): string {
  return isMegaCapTheme() ? "Bilhetes" : "Titulos";
}

/** Tudo em maiúsculas (botões): "TITULOS" | "BILHETES" */
export function labelPluralCaps(): string {
  return isMegaCapTheme() ? "BILHETES" : "TITULOS";
}

/** "Títulos de Capitalização" | "Bilhetes Premiados" (Helmet / documento) */
export function titulosDeCapitalizacao(): string {
  return isMegaCapTheme()
    ? "Bilhetes Premiados"
    : "Títulos de Capitalização";
}

/** "título de capitalização" | "bilhete de capitalização" */
export function tituloDeCapitalizacaoLower(): string {
  return isMegaCapTheme()
    ? "bilhete de capitalização"
    : "título de capitalização";
}

/** "Título de Capitalização" | "Bilhete de Capitalização" (início de frase legal) */
export function tituloDeCapitalizacaoTitle(): string {
  return isMegaCapTheme()
    ? "Bilhete de Capitalização"
    : "Título de Capitalização";
}
